export default __webpack_public_path__ + "img/3b0f3093a6354eee.68681936225bdfce3a09d65dc573be1d.jpeg";